<template>
  <div v-if="!isSelectedOptionEmpty" class="pm__price-wrapper">
    <div :class="['pm__price', {'bold': productMinPrice !=  productMaxPrice || customerDiscountVal > 0 || discountPrice != actualPrice}]">{{discountPrice}}</div>
    <div class="pm__price-seperator" v-if="customerDiscountVal > 0 && discountPrice != actualPrice">
      <span class="pm__compare-price">{{actualPrice}}</span>
      <span class="pm__price-saveText">{{youSave(actualPrice,discountPrice)}}</span>
    </div>
    <div class="pm__price-seperator" v-if="discountPrice != actualPrice && customerDiscountVal === 0">
      <span class="pm__compare-price">{{compareAtPrice}}</span>
      <span class="pm__price-saveText">{{youSave(compareAtPrice,discountPrice)}}</span>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onBeforeMount } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    selectedFirstOption: {
      type: Object,
      default: () => ({})
    }    
  })
  const {
    product,
    selectedFirstOption
  } = toRefs(props)

  var customerDiscountVal = ref(0)

  onBeforeMount(() => {
    getCustomerDiscount();
  })

  const discountPrice = computed(() => {
    return window.formattedPrice(discountPriceLogic(selectedFirstOption.value))
  })

  const isSelectedOptionEmpty = computed(() => Object.keys(selectedFirstOption.value).length === 0);

   const discountPriceLogic = (data) => {
    if(data.compare_at_price > 0){
      if(data.compare_at_price * (1 - customerDiscountVal.value) < data.price){
        return (data.compare_at_price) * (1 - customerDiscountVal.value)
      }else{
        return (data.price)
      }
    }else{
      return (data.price) * (1 - customerDiscountVal.value)
    }
  }

  const actualPrice = computed(() => {
    if(selectedFirstOption.value.compare_at_price > 0){
      return window.formattedPrice(selectedFirstOption.value.compare_at_price)
    }else{
      return window.formattedPrice(selectedFirstOption.value.price)
    }
  })

  const compareAtPrice = computed(() => {
    return window.formattedPrice(selectedFirstOption.value.compare_at_price)
  })

  const productMinPrice = computed(() => {
    return window.formattedPrice(product.value.min_price/100)
  })

  const productMaxPrice = computed(() => {
    return window.formattedPrice(product.value.max_price/100)
  })

  const youSave = (price,secondPrice) =>{
    var finalPrice = (parseFloat(price.replace('$', '')) - parseFloat(secondPrice.replace('$', '')))
    return finalPrice % 1 != 0 ? 'You save: $' +  finalPrice.toFixed(2) : 'You save: $' +  finalPrice
  }
  
  const getCustomerDiscount = () => {
    customerDiscountVal.value = window.customerDiscount(product.value.tags)
  }
</script>